import { AwardType, Offer } from '@ocx/data-offers';

import { getOfferLabelType } from './get-offer-label-type.utils';
import { OfferCardLabel } from './offer-card.types';

export const getOfferLabel = (offer: Offer): OfferCardLabel | null => {
  const type = getOfferLabelType(offer);

  if (!type) {
    return null;
  }

  if (type === 'Reward') {
    return {
      type: 'Reward',
      voucherCount: offer.voucherCount,
    };
  }

  if (type === 'Gameplay') {
    return {
      type: 'Gameplay',
    };
  }

  if (type === 'VoucheredGameplay') {
    return {
      type: 'VoucheredGameplay',
      voucherCount: offer.voucherCount,
    };
  }

  if (type === 'Entries') {
    const entries =
      offer.earningMechanism?.award?.type === AwardType.SweepstakeEntries
        ? offer.earningMechanism.award.memberEntries
        : 0;
    return {
      type: 'Entries',
      entries,
    };
  }

  return {
    type,
  };
};
